<template>
    <section class="scrollama_map_container">

        <h3 class="scrollama_title_map">Les victimes habitent plutôt dans le sud</h3>

        <Scrollama @step-enter="stepEnterHandler" :offset="0.6" id="3">
             <div slot="graphic" class="graphic map1" id="map_victimes">
              </div>
            <div class="step" data-step="a"><p>Les régions du sud-est sont les plus touchées.</p></div>
            <div class="step" data-step="b"><p>17,3 % des victimes habitent en PACA.</p></div>
            <div class="step" data-step="c"><p>Les victimes du sud-est sont celles aussi qui ont perdu le plus d'argent.</p></div>
            <div class="step" data-step="d"><p>A l'origine de l'étude, l'AMF n'a pas véritablement d'explications à cette particularité, évoquant simplement une question de sociologie liée à la présence plus importante de retraités dans ces régions.</p></div>
        </Scrollama>


    </section>

</template>

<script>
import "intersection-observer";
import Scrollama from "vue-scrollama";

export default{
    name:"VictimesMap",
    components: {
        Scrollama,
    },
    data(){
        return {

        }
    },
    methods:{
        stepEnterHandler({element, index, direction}){
            // handle the step-event as required here
            console.log(element, index, direction)
            var my_map = document.getElementById("map_victimes");

            // ICI on va changer le highlightning sur le graph
            if (index > 1) {
                my_map.classList.add("map2")
            } else {
                my_map.classList.remove("map2")
            }
        }
    }
  }
</script>

<style>
.scrollama_map_container{
    position:relative;
    top:10vh;
    height:100%;
    width:100%;
    display:flex;
    flex-direction:column;
    justify-content:space-around;
    text-align:center;
}

.map1{

    background-image: url("/img/cartes_et_graphs/carte_souscripteurs.svg");
    background-size: contain;
    background-repeat: no-repeat;
    transform: translateY(10%);

}

.map2{
    left:-2px;
    background-image: url("/img/cartes_et_graphs/carte_montants.svg");
    background-size: contain;
    background-repeat: no-repeat;
    transform: translateY(9.7%) translateX(1.5%);
}


@media screen and (max-width:1000px) and (min-width:431px){
    .scrollama_map_container{
        position:relative;
        top:20vh;
        height:100%;
        width:100%;
        display:flex;
        flex-direction:column;
        justify-content:space-around;
        align-items:center;
    }
}
@media screen and (max-width:430px){
    .scrollama_map_container{
        position:relative;
        top:5vh;
        height:100%;
        width:100%;
        display:flex;
        flex-direction:column;
        justify-content:space-around;
        align-items:center;
    }
}

@media screen and (min-width:1000px){
    #scrollama-steps-3{
        position: relative;
        top: -31vh;
    }
}


</style>

<style scoped>


    .step {
        position:relative;
        display:block;
        width:30%;
        margin-bottom:10%;
        padding:2%;
        background-color:rgba(255, 255, 255, 1);
        left:67%;
    }






    .graphic {
        position:relative;
        height: 80vh;
        top:20%;
        margin: 0 3rem;
        display: flex;
        align-items:center;
        justify-content: flex-start;
        font-size: 5rem;
    }

    .scrollama_title_map{
        width:100vw;
        text-align:center;
        margin-bottom:0vh;
    }





    @media screen and (max-width:1000px){
        .step {
            position:relative;
            display:flex;
            flex-direction: column;
            justify-content:center;
            width:90vw;
            padding:0px;
            margin-bottom:70%;
            background-color:rgba(255, 255, 255, 1);
            left:0px;
        }

        .graphic {
            position:relative;
            height: 40vh;
            width:90vw;
            top:0%;
            margin:0;
            display: flex;
            align-items:center;
            justify-content: center;
            font-size: 5rem;
        }


        .map1{
            transform: translateY(0%);

        }

        .map2{
            transform: translateY(0%) translateX(3%);

        }


        .scrollama_title_map{
            width:90vw;
            margin-top: 0;
            margin-bottom:5vh;
        }

    }



</style>




